<template>
  <div class="knw-button-list-wrapper" role="group">
    <div v-for="(button, index) in getButtons" :key="index" class="knw-button-list">
      <MessageButton
        :button="button"
        variant="buttonList"
        source="buttonList"
        @on-intent="($event) => $emit('onIntent', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import MessageButton from "@/components/messages/MessageButton/MessageButton.vue";
import type { ButtonList } from "@/services/bot/messageBuilder";
import type { Intent } from "@/types";
import { computed } from "vue";

const props = defineProps<{
  message: ButtonList;
}>();

defineEmits<{
  onIntent: [intent: Intent];
}>();

const getButtons = computed(() => props.message.data.buttons);
</script>

<style lang="scss" scoped>
.knw-button-list-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
  min-width: 0;

  .knw-button-list {
    max-width: 100%;
    display: flex;
  }
}
</style>
